function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.40186 2.22925C7.91673 2.74378 8.43337 3.25683 8.9459 3.7737C9.84972 4.68531 9.85147 5.74862 8.95117 6.6532C8.30538 7.30214 7.6634 7.95488 7.00501 8.59064C6.83104 8.75844 6.81728 8.89666 6.90543 9.10809C7.33772 10.1462 7.96272 11.0654 8.66591 11.9299C10.0793 13.6673 11.6778 15.2094 13.5842 16.406C13.9924 16.6622 14.4441 16.8488 14.8693 17.0795C15.0881 17.1981 15.238 17.1603 15.4132 16.9794C16.0572 16.3137 16.7168 15.6628 17.3749 15.0106C18.2368 14.1567 19.3187 14.1549 20.1844 15.0124C21.2423 16.0601 22.2955 17.1129 23.3443 18.1695C24.2241 19.0556 24.217 20.1385 23.3323 21.0311C22.7345 21.6344 22.1028 22.2069 21.5375 22.8388C20.7148 23.7586 19.6827 24.0565 18.5021 23.9914C16.7862 23.8971 15.2032 23.3279 13.6788 22.587C10.2902 20.9403 7.39337 18.6582 4.97011 15.774C3.17829 13.6416 1.69751 11.3208 0.723701 8.69958C0.252756 7.43187 -0.0840512 6.13341 0.0184554 4.75999C0.0817166 3.9125 0.400073 3.19153 1.02478 2.59706C1.69546 1.95838 2.33452 1.2866 2.99525 0.637077C3.8604 -0.213627 4.94258 -0.21187 5.80979 0.639419C6.34516 1.16478 6.87146 1.69892 7.40186 2.22925Z",
  fill: "black"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
})));

function SvgTelc1Df0838(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelc1Df0838);
export default __webpack_public_path__ + "static/media/tel.c1df0838.6a24102f.svg";
export { ForwardRef as ReactComponent };